"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("rxjs/add/operator/let");
var helpers_1 = require("./helpers");
/**
 * Selects an observable from the store, and attaches it to the decorated
 * property.
 *
 * @param selector
 * A selector function, property name string, or property name path
 * (array of strings/array indices) that locates the store data to be
 * selected
 *
 * @param comparator Function used to determine if this selector has changed.
 */
function select(selector, comparator) {
    return function (target, key) {
        var adjustedSelector = selector ?
            selector :
            (key.lastIndexOf('$') === key.length - 1) ?
                key.substring(0, key.length - 1) :
                key;
        decorate(adjustedSelector, undefined, comparator)(target, key);
    };
}
exports.select = select;
/**
 * Selects an observable using the given path selector, and runs it through the given
 * transformer function. A transformer function takes the store observable as an input and
 * returns a derived observable from it. That derived observable is run through
 * distinctUntilChanges with the given optional comparator and attached to the store property.
 *
 * Think of a Transformer as a FunctionSelector that operates on observables instead of
 * values.
 */
function select$(selector, transformer, comparator) {
    return decorate(selector, transformer, comparator);
}
exports.select$ = select$;
function decorate(selector, transformer, comparator) {
    return function decorator(target, key) {
        function getter() {
            return helpers_1.getInstanceSelection(this, key, selector, transformer, comparator);
        }
        // Replace decorated property with a getter that returns the observable.
        if (delete target[key]) {
            Object.defineProperty(target, key, {
                get: getter,
                enumerable: true,
                configurable: true
            });
        }
    };
}
//# sourceMappingURL=select.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/admin/Documents/Visual Studio 2017/Projects/VanzAngularEcommerce/~/@angular-redux/store/lib/src/decorators/select.js
// module id = ../../../../@angular-redux/store/lib/src/decorators/select.js
// module chunks = 3